module.exports = __webpack_public_path__ + "img/project19_4.png.a9c3eb24.webp";